// src/createHorizontalRulePlugin.ts
import { createPluginFactory } from "@udecode/plate-common/server";
var ELEMENT_HR = "hr";
var createHorizontalRulePlugin = createPluginFactory({
  deserializeHtml: {
    rules: [
      {
        validNodeName: "HR"
      }
    ]
  },
  isElement: true,
  isVoid: true,
  key: ELEMENT_HR
});
export {
  ELEMENT_HR,
  createHorizontalRulePlugin
};
//# sourceMappingURL=index.mjs.map